import React, { useEffect, useRef, useState } from 'react'

type UseHoverType<T extends HTMLElement> = [React.RefObject<T>, boolean]

function useHover<T extends HTMLElement>(): UseHoverType<T> {
  const [value, setValue] = useState(false)

  const hoverRef = useRef<T>(null)

  const handleMouseOver = () => setValue(true)
  const handleMouseOut = () => setValue(false)

  useEffect(
    () => {
      const node = hoverRef.current
      if (node) {
        node.addEventListener('mouseover', handleMouseOver)
        node.addEventListener('mouseout', handleMouseOut)

        return () => {
          node.removeEventListener('mouseover', handleMouseOver)
          node.removeEventListener('mouseout', handleMouseOut)
        }
      }
    },
    [hoverRef.current] // Recall only if ref changes
  )

  return [hoverRef, value]
}

export default useHover
